export default "__VITE_ASSET__Bt1yYdph__"